export const getApiErrorMessage = (error: unknown, fallback: string) => {
  if (!error || typeof error !== 'object' || !('data' in error)) {
    return fallback;
  }

  const data = error.data;
  if (typeof data === 'string' && data.trim()) {
    return data;
  }

  if (data && typeof data === 'object' && 'message' in data) {
    const message = data.message;
    if (typeof message === 'string' && message.trim()) {
      return message;
    }
  }

  return fallback;
};
